// Reusable shimmer skeleton components

function Shimmer({ width = '100%', height = 14, radius = 6, style = {} }) {
  return (
    <div style={{
      width, height, borderRadius: radius,
      background: 'linear-gradient(90deg, rgba(255,255,255,0.04) 25%, rgba(255,255,255,0.08) 50%, rgba(255,255,255,0.04) 75%)',
      backgroundSize: '200% 100%',
      animation: 'shimmer 1.5s ease-in-out infinite',
      flexShrink: 0,
      ...style,
    }} />
  );
}

export function MessageSkeleton({ count = 6 }) {
  const rows = Array.from({ length: count }, (_, i) => ({
    grouped: i > 0 && Math.random() > 0.5,
    lineCount: Math.floor(Math.random() * 2) + 1,
    width: `${55 + Math.random() * 40}%`,
  }));

  return (
    <>
      <style>{`@keyframes shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }`}</style>
      <div style={{ padding: '8px 0' }}>
        {rows.map((r, i) => (
          <div key={i} style={{ display: 'flex', gap: 12, padding: r.grouped ? '3px 16px 3px 60px' : '8px 16px', alignItems: 'flex-start' }}>
            {!r.grouped && <Shimmer width={36} height={36} radius={18} />}
            <div style={{ flex: 1, minWidth: 0 }}>
              {!r.grouped && (
                <div style={{ display: 'flex', gap: 10, marginBottom: 6, alignItems: 'center' }}>
                  <Shimmer width={90} height={12} />
                  <Shimmer width={44} height={10} />
                </div>
              )}
              <Shimmer width={r.width} height={13} style={{ marginBottom: r.lineCount > 1 ? 4 : 0 }} />
              {r.lineCount > 1 && <Shimmer width={`${30 + Math.random() * 30}%`} height={13} />}
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export function MemberSkeleton({ count = 8 }) {
  return (
    <>
      <style>{`@keyframes shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }`}</style>
      <div style={{ padding: '8px 0' }}>
        {/* Category label */}
        <Shimmer width={80} height={10} style={{ margin: '10px 12px 8px' }} />
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 10px' }}>
            <Shimmer width={30} height={30} radius={15} />
            <div style={{ flex: 1 }}>
              <Shimmer width={`${40 + Math.random() * 35}%`} height={12} style={{ marginBottom: 4 }} />
              <Shimmer width={`${20 + Math.random() * 25}%`} height={9} />
            </div>
          </div>
        ))}
      </div>
    </>
  );
}

export function ChannelSkeleton({ count = 5 }) {
  return (
    <>
      <style>{`@keyframes shimmer { 0%{background-position:200% 0} 100%{background-position:-200% 0} }`}</style>
      <div style={{ padding: '8px 0' }}>
        <Shimmer width={70} height={9} style={{ margin: '10px 12px 8px' }} />
        {Array.from({ length: count }).map((_, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '5px 10px' }}>
            <Shimmer width={14} height={14} radius={4} />
            <Shimmer width={`${35 + Math.random() * 40}%`} height={12} />
          </div>
        ))}
      </div>
    </>
  );
}
